//Base modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER  } from '@angular/core';
import {ReactiveFormsModule,FormsModule} from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';

import { AgmOverlays } from "agm-overlays"

//Utility modules
import { HttpClientModule } from '@angular/common/http';

//Modules datepicker
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


//Modules Maps
import { AgmCoreModule } from '@agm/core';

//Component modules
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PortabilityComponent } from './portability/portability.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { CombosComponent } from './combos/combos.component';
import { RechargeComponent } from './recharge/recharge.component';
import { FrequentQuestionsComponent } from './frequent-questions/frequent-questions.component';
import { RegistrationGuideComponent } from './registration-guide/registration-guide.component';
import { CombosHomeComponent } from './combos-home/combos-home.component';
import { BenefitsComponent } from './benefits/benefits.component';
import { CareChannelsComponent } from './care-channels/care-channels.component';
import { ServiceMenuHomeComponent } from './service-menu-home/service-menu-home.component';
import { SuspendLineEquipComponent } from './suspend-line-equip/suspend-line-equip.component';
import { ActivationPassportComponent } from './activation-passport/activation-passport.component';
import { ActivationMenuComponent } from './activation-menu/activation-menu.component';
import { ActivationDocumentComponent } from './activation-document/activation-document.component';
import { CallLogDetailComponent } from './call-log-detail/call-log-detail.component';
import { ReleaseLineEquipComponent } from './release-line-equip/release-line-equip.component';
import { ChangeNumberComponent } from './change-number/change-number.component';
import { RatesFooterComponent } from './rates-footer/rates-footer.component';
import { CareChannelsFooterComponent } from './care-channels-footer/care-channels-footer.component';
import { ChangeChipComponent } from './change-chip/change-chip.component';
import { LoginComponent } from './login/login.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { AuthGuardComponent } from './auth-guard/auth-guard.component';
import { LogoutComponent } from './logout/logout.component';
import { BasicInfoHeaderComponent } from './basic-info-header/basic-info-header.component';
import { FilterBenefitsWithSocialNetworkPipe, FilterBenefitsWithoutSocialNetworkPipe } from './combos-home/app-combos.pipes';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { PaymentViewUrlokComponent } from './payment-view-urlok/payment-view-urlok.component';
import { PaymentViewUrlerrorComponent } from './payment-view-urlerror/payment-view-urlerror.component';
import { EditUserInfoComponent } from './edit-user-info/edit-user-info.component';
import { BalancesAndBoltonsComponent } from './balances-and-boltons/balances-and-boltons.component';
import { BalanceAndBoltonsDatePipe, BalanceAndBoltonsDateDiff, BalanceAndBoltonsDateHoursDiff } from './balances-and-boltons/balance-and-boltons.pipe';
import { HelpComponent } from './help/help.component';
import { ModalInfoComponent } from './modal-info/modal-info.component';
import { CoverageComponent } from './coverage/coverage.component';
import { ComboWizardComponent } from './combos/combo-wizard/combo-wizard.component';
import { HomologationComponent } from './homologation/homologation.component';
//import { MovistarPlayComponent } from './movistar-play/movistar-play.component';
import { PaymentViewUrlerrorRecurrentComponent } from './payment-view-urlerror-recurrent/payment-view-urlerror-recurrent.component';
import { PaymentViewUrlokRecurrentComponent } from './payment-view-urlok-recurrent/payment-view-urlok-recurrent.component';
import { NormativeComponent } from './normative/normative.component';
import { SignatureComponent } from './signature/signature.component';
import { MapsCoverageComponent } from './maps-coverage/maps-coverage.component';
import { FilterOneComponent } from './maps-coverage/filter-one/filter-one.component';
import { FilterTwoComponent } from './maps-coverage/filter-two/filter-two.component';
import { FilterThreeComponent } from './maps-coverage/filter-three/filter-three.component';
import { FilterFourComponent } from './maps-coverage/filter-four/filter-four.component';

import { Uso911Component } from './uso911/uso911.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { MainMenuCookiesComponent } from './cookies-component/main-menu.component';
import { CookieService } from 'ngx-cookie-service';
import { FormPrivacyComponent } from './form-privacy/form-privacy.component';
import { WigdetPersonalDataComponent } from './wigdet-personal-data/wigdet-personal-data.component';
import { FormPersonalDataComponent } from './form-personal-data/form-personal-data.component';

/*
export function initSessionKeys(sessionKeyService: SessionKeyService) {
  return () => sessionKeyService.init();
}
  */

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FooterComponent,
    HeaderComponent,
    PortabilityComponent,
    TermsConditionsComponent,
    CombosComponent,
    RechargeComponent,
    FrequentQuestionsComponent,
    RegistrationGuideComponent,
    CombosHomeComponent,
    BenefitsComponent,
    CareChannelsComponent,
    ServiceMenuHomeComponent,
    SuspendLineEquipComponent,
    ActivationMenuComponent,
    ActivationPassportComponent,
    CallLogDetailComponent,
    ActivationDocumentComponent,
    ReleaseLineEquipComponent,
    ChangeNumberComponent,
    ChangeChipComponent,
    RatesFooterComponent,
    CareChannelsFooterComponent,
    LoginComponent,
    MyAccountComponent,
    AuthGuardComponent,
    LogoutComponent,
    BasicInfoHeaderComponent,
    FilterBenefitsWithoutSocialNetworkPipe,
    FilterBenefitsWithSocialNetworkPipe,
    OrderHistoryComponent,
    CreateTicketComponent,
    PaymentViewUrlokComponent,
    PaymentViewUrlerrorComponent,
    EditUserInfoComponent,
	  BalancesAndBoltonsComponent,
    BalanceAndBoltonsDatePipe,
    BalanceAndBoltonsDateHoursDiff,
    BalanceAndBoltonsDateDiff,
    HelpComponent,
    ModalInfoComponent,
    CoverageComponent,
    HomologationComponent,
    ComboWizardComponent,
    //MovistarPlayComponent,
    PaymentViewUrlerrorRecurrentComponent,
    PaymentViewUrlokRecurrentComponent,
    NormativeComponent,
    PrivacyComponent,
    SignatureComponent,
    MapsCoverageComponent,
    NormativeComponent,
    FilterOneComponent,
    FilterTwoComponent,
    FilterThreeComponent,
    FilterFourComponent,
    Uso911Component,
    MainMenuCookiesComponent,
    FormPrivacyComponent,
    WigdetPersonalDataComponent,
    FormPersonalDataComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    AgmOverlays,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBxHP0hS6bG3ze9nYy7adOKH5KAP2QWs_k',
      libraries: ["places"]
    }),
    // CookieModule.withOptions()
  ],
  providers: [
    // Protección de rutas
    AuthGuardComponent,

    // Manejo de cookies
    CookieService,

    // Inicialización de claves de sesión antes de cargar la app
    /*
    {
      provide: APP_INITIALIZER,
      useFactory: initSessionKeys,
      deps: [SessionKeyService],
      multi: true
    },

    // Interceptor para cifrar peticiones HTTP
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecureHttpInterceptor,
      multi: true
    }*/
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
